import { render, staticRenderFns } from "./ConversationFilterV2.vue?vue&type=template&id=62895959&scoped=true"
import script from "./ConversationFilterV2.vue?vue&type=script&lang=js"
export * from "./ConversationFilterV2.vue?vue&type=script&lang=js"
import style0 from "./ConversationFilterV2.vue?vue&type=style&index=0&id=62895959&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62895959",
  null
  
)

export default component.exports